import CustomAlert from "components/generals/alert/CustomAlert";
import { AuthContext } from "components/authProvider/authProvider";
import { host } from "config";
import React, { FC, useContext, useState } from "react";
import { Navigate, useNavigate, useLocation, useParams } from "react-router-dom";

type Props = {
  redirectPath?: string;
};

const FileDownloaderWithProgress: FC<Props> = ({ redirectPath = "/login" }) => {
  const [progress, setProgress] = useState(0);
  const [downloading, setDownloading] = useState(false);

  const [isAlertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const location = useLocation();
  const { userId: userId, fileName: fileName } = useParams();

  const authContext = useContext(AuthContext);
  if (!authContext) {
    throw new Error("AuthContext is undefined");
  }
  const { currentUser, role, selectedGroup } = authContext;

  const navigate = useNavigate();

  var tk: string;
  currentUser
    ?.getIdToken(false)
    .then((idToken: string) => {
      tk = idToken;
    })
    .catch((error: any) => {
      console.log(error);
    });

  if (!currentUser) {
    return <Navigate to={redirectPath} replace state={{ redirectTo: location }} />;
  }

  const downloadFile = async () => {
    try {
      setDownloading(true);
      const response = await fetch(`${host}/api/Reporting/Dataproc/Download/${userId}/${fileName}`, {
        headers: {
          Authorization: `Bearer ${tk}`,
        },
      });

      if (!response.ok) throw new Error(`Download failed: ${response.status}`);

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      const contentLength = response.headers.get("Content-Length");
      if (contentLength) {
        setProgress(100);
      }

      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      setTimeout(() => {
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        setDownloading(false);
      }, 100);
    } catch (error) {
      setAlertMessage(error);
      setAlertOpen(true);
      setDownloading(false);
    }
  };

  return (
    <div>
      <CustomAlert message={alertMessage} isOpen={isAlertOpen} onClose={() => setAlertOpen(false)} />
      <button onClick={() => downloadFile()} disabled={downloading}>
        Download Large File
      </button>

      {/* {downloading && (
        <div>
          <progress value={progress} max="100" />
          <span>{progress}%</span>
        </div>
      )} */}
    </div>
  );
};

export default FileDownloaderWithProgress;
